<template>
  <div class="list-modal h-card shadow">
    <div class="card-header">
      <div class="modal-title">Комментарии к броням</div>
      <button type="button" @click="closeCmodal" class="btn-close" data-bs-dismiss="modal"
              aria-label="Закрыть"></button>
    </div>
    <div class="card-body">
      <template v-for="(bData,id) in bookingData" :key="id">
        <div class="block-line">
          <div class="d-flex gap-3 ">
              <span class="hourBlock">
                <span class="block">{{ timeView1(bData) }}</span>
                -
                <span class="block">{{ timeView2(bData) }}</span>
              </span>
            <div class="flex-fill">
              <div v-if="bData.comment ||bData.commentTenant">
                <template v-if="bData.comment ||bData.commentTenant">
                  <div>
                    <template  v-if="bData.commentTenant">
                      <div class="label">Комментарий:</div>
                      <div class="mycomment mb-2">{{ bData.commentTenant }}</div>
                    </template>
                    <template  v-if="bData.comment">
                      <div class="label adm">Комментарий для администрации:</div>
                      <div class="mycomment adm">{{ bData.comment}}</div>
                    </template>
                  </div>
                  <div class="change-wrap">
                    <button class="add-comment-btn" @click="openModalAddComment(bData)">Изменить</button>
                  </div>
                </template>
                <template v-else>
                  <div class="label">Нет комментария</div>
                </template>

              </div>
              <div v-else class="add-btn-wrap h-100">
                <div class="label">Нет комментария</div>
                <button class="add-comment-btn" @click="openModalAddComment(bData)">Добавить</button>
              </div>
            </div>
          </div>

        </div>
      </template>
    </div>
    <div class="card-footer">
      <button class="close-btn" @click="closeCmodal">Закрыть</button>
    </div>


  </div>
</template>
<script>
import {closeModal, pushModal} from "jenesius-vue-modal";
import CommentModal from "@/components/MyBookings/CommentModal.vue";

export default {
  name: 'CommentList',
  props: {
    bookingData: Object,
  },
  computed: {},
  methods: {
    openModalAddComment(data) {
      const props = {data: data};
      pushModal(CommentModal, props)
    },
    timeView1(data) {
      return data.hour + ':' + data.minuteView;
    },
    timeView2(data) {
      let hour = data.minuteView == '30' ? data.hour + 1 : data.hour;
      let minute = data.minuteView == '30' ? '00' : '30';
      return hour + ':' + minute;
    },
    closeCmodal() {
      closeModal();
    },
  }
}
</script>
<style scoped>
.h-100 {
  height: 100%;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.change-wrap {
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
}

.add-btn-wrap {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.add-comment-btn {
  font-size: 0.7em;
  border: none;
  padding: 0.4em 1em;
  border-radius: 1em;
  background: #dd9f4c57;
  color: #704a00;
  line-height: 1.35em;
  border: 1px solid #fff;
  box-shadow: inset 0px 0px 0px 1px #34343417;
  /*text-shadow: 0px 1px 0px #fff;*/
  transition: all ease .3s;
}
.add-comment-btn:hover{
  background: #dd9f4c77;
}

.list-modal {
  width: 460px;
  max-height: 100vh;
  container-name: list-modal-container;
  container-type: inline-size;
}

.list-modal .card-body {
  padding: 0;
  overflow: auto;
  height: 400px;
  max-height: 95vh;
}

@container list-modal-container {
  .list-modal .card-body {
    height: 80cqh;
  }
}

.hourBlock {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 4em;
  width: 4.2em;
  min-width: 4.2em;
  border: 1px solid #c7bbbb7a;
  padding: 0.1rem 0.1rem;
  border-radius: 5px;
  font-size: .7em;
  line-height: 1em;
  align-items: center;
  color: #fff;
  background: #81b29a;
  justify-content: center;
  border: 1px solid #17573800;
  box-shadow: -4px 6px 10px 0px #211e1e40;
}

.block {
  display: block;
}

.mycomment {
  font-size: .85em;
}

.mycomment.adm {
  color: #782f36;
}

.label {
  font-size: 0.65em;
  color: #9f9f9f;
}

.label.adm {
//font-size: 0.65em; //color: #c15761;
}

.block-line {

  padding: 0.8em 0.8em 0.5em 0.8em;
  border-bottom: 1px solid #cf741c21;
}

.block-line:nth-of-type(2n) {
  background: #fff8db59;
}
</style>